import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/config";
import { parseUiLocaleFromSearch } from "../../i18n/urlLocale";
import TicketFlowWizard from "./TicketFlowWizard";

function resolvePublicLocale(search) {
  const fromUrl = parseUiLocaleFromSearch(search || "");
  if (fromUrl) return fromUrl;
  const supported = Array.isArray(i18n.options?.supportedLngs)
    ? i18n.options.supportedLngs.filter((code) => code && code !== "cimode")
    : [];
  if (supported.includes("pt-BR")) return "pt-BR";
  return supported[0] || "pt-BR";
}

export default function TicketFlowPage() {
  const [searchParams] = useSearchParams();
  const { i18n: i18nInst } = useTranslation("chat");
  const token = String(searchParams.get("token") || "").trim();
  const locale = useMemo(() => resolvePublicLocale(searchParams.toString()), [searchParams]);

  useEffect(() => {
    if (locale && i18nInst.language !== locale) {
      i18nInst.changeLanguage(locale);
    }
  }, [i18nInst, locale]);

  return (
    <Box sx={{ minHeight: "100dvh", bgcolor: "#0b141a" }}>
      <Box
        sx={{
          maxWidth: 520,
          mx: "auto",
          minHeight: "100dvh",
          bgcolor: "#fff",
          boxShadow: { sm: "0 0 24px rgba(0,0,0,0.35)" },
        }}
      >
        <TicketFlowWizard token={token} />
      </Box>
    </Box>
  );
}
